/**
 * Insurance Portal Feature Toggle Service Model
 * API Spec for Insurance Portal Feature Toggle Service Model
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum UserTypeDto {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  Customer = 'CUSTOMER',
}
